import React, { Component } from 'react';
import Button from '../components/Button';
import server from '../server';

class Catalog extends Component {

  state = {
    loading: true,

    page: false,
    product: false,

    activeItems: [],
  }

  componentDidMount() {
    if( this.state.page ) return 0;

    fetch(server.uri+'page/catalog', server.params)
      .then(response => response.json())
      .then(data =>
        this.setState({
          loading: false,
          page: data
        })
    );
  }
  
  handleToggleCatalog = id => {

    const activeItems = this.state.activeItems,
      index = activeItems.indexOf(id);

    if( index === -1 ) activeItems.push(id);
    else activeItems.splice(index,1);

    this.setState({ activeItems: activeItems });
    console.log(this.state.activeItems)
  }
  
  render() {

    if( this.state.loading )
      return <div className="loading"></div>;

    const page = this.state.page;
    
    return (
      <article className="page-catalog">
      
        <header className="main__header">
          <h1 className="main__title"><span>{page.pagetitle}</span></h1>
        </header>

        <section className="main__content" dangerouslySetInnerHTML={{ __html: page.content }}></section>

        <section className="catalog__items">
          <hr/>
          <ul>
            { page.items.map( (item,i) => (
              <li key={i}>
                <div className={'catalog__item'+( this.state.activeItems.indexOf(item.id) !== -1 ? ' active' : '' )+( item.items && item.items.length ? ' childs_exist' : '' )}>

                  <div className={'catalog__item__title'}>
                    <Button theme="text" handleClick={ () => this.handleToggleCatalog(item.id) }>
                      <i className="catalog__item__icon"></i>
                      { item.pagetitle }
                    </Button>
                  </div>

                  <ul className={'catalog__item__childs'} style={{ height: this.state.activeItems.indexOf(item.id) !== -1 ? ( ( item.items && item.items.length ? item.items.length : 1 ) * 34)+'px' : '0px' }}>
                    { item.items.map( (itemChild,j) =>
                      <li key={j}>
                        <div className="catalog__item__child">

                          <h3 className="catalog__item__child__title">
                            <i className="catalog__item__icon"></i>
                            <span>{itemChild.pagetitle}</span>
                          </h3>

                          <div className="catalog__item__child_btns">
                            <Button theme="info" handleClick={() => this.props.handleGetModalInfo(itemChild.uri)}>
                              <span className="hidden-xs">подробнее...</span>
                              <span className="visible-xs">...</span>
                            </Button>
                            <Button theme={'success'+( this.props.handleGetCardItemIndex(itemChild) !== -1 ? ' hide' : '' )}
                              handleClick={() => this.props.handleCardAdd(itemChild)}>
                              <span className="hidden-xs">добавить в корзину</span>
                              <span className="visible-xs">+</span>
                            </Button>
                            <Button theme={'danger'+( this.props.handleGetCardItemIndex(itemChild) === -1 ? ' hide' : '' )}
                              handleClick={() => this.props.handleCardRemove(itemChild)}>
                              <span className="hidden-xs">убрать из корзины</span>
                              <span className="visible-xs">-</span>
                            </Button>
                          </div>
                        </div>
                      </li>
                    )}
                    
                    <li className={'catalog__item__undefined'+( item.items && item.items.length ? ' hide' : '' )}>продукты не найдены</li>
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </article>
    );
  }
}
export default Catalog;
